// import { getStoredGuestExamUser } from ".././api/exam";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Mic } from "lucide-react";
import AudioService from "../services/audioService";
import DeepgramTranscriptionService from "../services/deepgramService";
import ExitExamDialog from "@/components/models/ExitExamDialog";
import { useAudioWave } from "@/hooks/waveData";
import logo from "./../../public/images/logo.png";
import { Button } from "@/components/ui/button";
import { getStaticAudioByType, StaticAudioType } from "../config/staticAudio";
import { getSessionId, getToken, clearToken } from "@/utils/storage";
import { updateTaskAttempt, getStoredGuestExamUser } from "../api/exam";
import "./task1.css";
import useBlocker from "../hooks/useBlocker";
import { checkSubscriptionAccess } from "@/utils/subscriptionCheck";
import {
  captureExamModeFromEntry,
  setExamMode,
  isTaskDeliberateTrial,
  isDeliberateTrial,
  getExamMode,
  planTaskOneTrialAuthGuard,
} from "@/utils/examMode";
import { isValidlyAuthenticated } from "@/utils/auth";
import { isTask2MaintenanceEnabled } from "@/config/maintenance";
import Task2MaintenancePage from "@/components/task2/Task2MaintenancePage";
import { playTrackedLiveExamAudio } from "@/lib/speaking/exam/live/liveExamRuntimeAudio";
import {
  isLiveExamRuntimeExiting,
  markLiveExamRuntimeExiting,
} from "@/lib/speaking/exam/live/liveExamRuntimeTeardown";

// Function to call grammar-vocab-comprehension edge function
// const callGrammarAnalysis = async (sessionId: string) => {
//   try {
//     console.log("🎯 Calling grammar analysis for session:", sessionId);
//     // 1) Get tokens
//     const paidToken = getToken();
//     const guestUser = getStoredGuestExamUser();
//     const guestToken = guestUser?.token ?? localStorage.getItem("guestToken");

//     // 2) Decide which mode
//     const isGuest = !paidToken && !!guestToken;
//     const token = paidToken || guestToken;

//     if (!token) {
//       console.error("❌ No paid or guest token available for grammar analysis");
//       return null;
//     }

//     // 3) Build payload
//     const payload: any = {
//       task_type: 1, // 👈 task_one
//       session_id: sessionId,
//     };

//     if (isGuest) {
//       payload.guest_id = guestUser?.user_id;
//       payload.is_guest = true;
//     }


//     // 4) Send request
//     const response = await fetch(
//       "https://nluntjftnyzlxhatvvks.supabase.co/functions/v1/gramm-vocab-compre",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`, // works for both paid + guest
//         },
//         body: JSON.stringify(payload),
//       }
//     );

//     if (!response.ok) {
//       throw new Error(`Grammar analysis failed: ${response.status}`);
//     }

//     const result = await response.json();
//     console.log('✅ Grammar analysis completed:', result);

//     // Check if this is a retry attempt and update task attempt
//     const currentAttemptId = localStorage.getItem('current_task_attempt_id');
//     if (currentAttemptId && result.success) {
//       console.log('🎯 TASK 1 RETRY - Updating task attempt with scoring data:', currentAttemptId);

//       try {
//         const updateData: any = {
//           taskAttemptId: currentAttemptId
//         };

//         // Add scoring data if available
//         if (result.grammar !== undefined) updateData.grammar = result.grammar;
//         if (result.vocabulary !== undefined) updateData.vocabulary = result.vocabulary;
//         if (result.comprehension !== undefined) updateData.comprehension = result.comprehension;
//         if (result.fluency !== undefined) updateData.fluency = result.fluency;
//         if (result.pronunciation !== undefined) updateData.pronunciation = result.pronunciation;
//         if (result.averageScore !== undefined) updateData.averageScore = result.averageScore;
//         if (result.estimatedCefr !== undefined) updateData.estimatedCefr = result.estimatedCefr;
//         if (result.strength !== undefined) updateData.strength = result.strength;
//         if (result.weakness !== undefined) updateData.weakness = result.weakness;
//         if (result.grammarTips !== undefined) updateData.grammarTips = result.grammarTips;
//         if (result.vocabTips !== undefined) updateData.vocabTips = result.vocabTips;
//         if (result.rewrittenResponse !== undefined) updateData.rewrittenResponse = result.rewrittenResponse;

//         // Get transcript from localStorage if available
//         const transcript = localStorage.getItem('current_task_transcript');
//         if (transcript) {
//           updateData.transcript = transcript;
//         }

//         const updateResponse = await updateTaskAttempt(updateData);
//         if (updateResponse.success) {
//           console.log('✅ TASK 1 RETRY - Task attempt updated successfully');

//           // Call final scoring analysis to update exam results
//           try {
//             console.log('🎯 TASK 1 RETRY - Calling final scoring analysis...');

//             // Build final scoring payload with guest support
//             const finalScoringPayload: any = { session_id: sessionId };
//             if (isGuest) {
//               finalScoringPayload.guest_id = guestUser?.user_id;
//               finalScoringPayload.is_guest = true;
//             }

//             const finalScoringResponse = await fetch('https://nluntjftnyzlxhatvvks.supabase.co/functions/v1/final-scoring-analysis', {
//               method: 'POST',
//               headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${token}`
//               },
//               body: JSON.stringify(finalScoringPayload)
//             });

//             if (finalScoringResponse.ok) {
//               const finalScoringData = await finalScoringResponse.json();
//               console.log('✅ TASK 1 RETRY - Final scoring analysis completed:', finalScoringData);
//             } else {
//               console.error('❌ TASK 1 RETRY - Final scoring analysis failed:', finalScoringResponse.status);
//             }
//           } catch (finalScoringError) {
//             console.error('❌ TASK 1 RETRY - Error calling final scoring analysis:', finalScoringError);
//           }

//           // Clear the stored attempt ID and transcript
//           localStorage.removeItem('current_task_attempt_id');
//           localStorage.removeItem('current_task_transcript');
//         } else {
//           console.error('❌ TASK 1 RETRY - Failed to update task attempt:', updateResponse.message);
//         }
//       } catch (updateError) {
//         console.error('❌ TASK 1 RETRY - Error updating task attempt:', updateError);
//       }
//     }

//     return result;
//   } catch (error) {
//     console.error("❌ Grammar analysis error:", error);
//     return null;
//   }
// };



const TaskOne = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationExamId = location.state?.examId;
  const isRetryAttempt = localStorage.getItem('current_task_attempt_id');
  const audioServiceRef = useRef<AudioService | null>(null);
  const speechRecognitionRef = useRef<DeepgramTranscriptionService | null>(null);
  const skipAutostartRef = useRef(false);

  // Check subscription access on mount
  useEffect(() => {
    if (locationExamId) {
      // Individual Task / retry re-entry is always Full/paid authority.
      setExamMode("full");
    } else {
      // Explicit signal only; a missing mode here must NOT become Trial (that
      // would convert a paid re-entry into a guest bootstrap).
      captureExamModeFromEntry({
        stateExamMode: (location.state as { examMode?: unknown } | null)?.examMode,
      });
    }

    // Direct /task-one Trial edge: MicTest already cleared stale paid auth for
    // the normal Trial path, but refresh/history/direct same-tab entry can keep
    // exam_mode=trial with a leftover expired access_token. Presence-only
    // isLoggedIn() would then feed that JWT to the Task 1 websocket.
    // Trial-auth uses exam_mode only (isDeliberateTrial). Leftover current_exam_id
    // must not suppress guest-only Trial cleanup/redirect.
    const trialAuthGuard = planTaskOneTrialAuthGuard({
      deliberateTrial: isDeliberateTrial(),
      isValidlyAuthenticated: isValidlyAuthenticated(),
      hasAccessToken: !!getToken(),
    });
    if (trialAuthGuard.action === "redirectDashboard") {
      skipAutostartRef.current = true;
      navigate("/dashboard", { replace: true });
      return;
    }
    if (trialAuthGuard.action === "clearStaleAccessToken") {
      // Clear ONLY the custom access_token. That is what isLoggedIn() / Task 1
      // websocket auth read. Do not clear Supabase auth or unrelated exam state.
      clearToken();
    }

    const checkAccess = async () => {
      const result = await checkSubscriptionAccess({
        deliberateTrial: isTaskDeliberateTrial({
          hasLocationExamId: !!locationExamId,
          hasCurrentExamId: !!localStorage.getItem("current_exam_id"),
          examMode: getExamMode(),
        }),
      });
      if (!result.hasAccess) {
        console.log('❌ Task 1: Subscription access denied -', result.reason);
        window.location.href = '/subscription';
      }
    };
    checkAccess();
  }, [navigate]);

  // Handle examId from location state for retry attempts
  useEffect(() => {
    if (locationExamId) {
      localStorage.setItem("current_exam_id", locationExamId);
      console.log('🎯 TASK 1 - Set examId from location state for retry:', locationExamId);
    }
  }, [locationExamId]);

  // UI State
  // Expose to global so other UI (navbar, processing screens) can stop recording
  (window as any).audioServiceRef = audioServiceRef;
  const [showPreStartMessage, setShowPreStartMessage] = useState(true);
  const [isRecording, setIsRecording] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [remainingSeconds, setRemainingSeconds] = useState(120);
  const [examStarted, setExamStarted] = useState(false);
  const [userHasSpokenFirst, setUserHasSpokenFirst] = useState(false);

  // Audio and Connection State
  const [status, setStatus] = useState("Ready to start");
  const [isConnected, setIsConnected] = useState(false);
  const [fullTranscript, setFullTranscript] = useState("");
  const [liveTranscript, setLiveTranscript] = useState("");
  // Collect all AI questions for Task 1 (preserve history like Task 2)
  const [aiQuestions, setAiQuestions] = useState<string[]>([
    "Tâche 1, Parlez-moi de vous pendant environ 2 minutes."
  ]);
  const [currentDisplayedQuestion, setCurrentDisplayedQuestion] = useState<string | null>(null);
  const [isAISpeaking, setIsAISpeaking] = useState(false);
  const [isUserSpeaking, setIsUserSpeaking] = useState(false);
  const [userHasResponded, setUserHasResponded] = useState(false);
  const [timerActive, setTimerActive] = useState(false);
  const [showDivider, setShowDivider] = useState(false);
  const [taskEnded, setTaskEnded] = useState(false);
   const isWaveActive = isRecording && isUserSpeaking;
  const messagesRef = useRef<HTMLDivElement | null>(null);
  const [allowInternalNavigation, setAllowInternalNavigation] = useState(false);


  // Auto-scroll to bottom when new AI questions arrive
  useEffect(() => {
    if (messagesRef.current) {
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
    }
  }, [aiQuestions]);

  // Health check for voice detection - ensure it stays active during exam
  useEffect(() => {
    if (!examStarted || !isRecording || !timerActive) return;

    const healthCheckInterval = setInterval(() => {
      if (speechRecognitionRef.current && typeof speechRecognitionRef.current.isActive === 'function') {
        const isActive = speechRecognitionRef.current.isActive();
        const isHealthy = speechRecognitionRef.current.isHealthy?.() ?? true;

        if (!isActive || !isHealthy) {
          console.log("🔄 Voice detection not active/healthy, restarting...");
          speechRecognitionRef.current.start();
        } else {
          // Only log occasionally to reduce noise
          if (remainingSeconds % 15 === 0) {
            console.log("✅ Voice detection is active and healthy");
          }
        }
      }
    }, 5000); // Check every 5 seconds to reduce noise

    return () => clearInterval(healthCheckInterval);
  }, [examStarted, isRecording, timerActive, remainingSeconds]);

  // Mobile-specific touch handling for better interruption
  useEffect(() => {
    if (!examStarted || !isRecording) return;

    const handleTouchStart = () => {
      // Resume audio context on touch (mobile requirement)
      const ctx = (window as any).__appAudioContext;
      if (ctx && ctx.state === 'suspended') {
        ctx.resume().catch(() => { });
      }

      // Ensure microphone is active on touch
      if (speechRecognitionRef.current && typeof speechRecognitionRef.current.isActive === 'function') {
        const isActive = speechRecognitionRef.current.isActive();
        if (!isActive) {
          console.log("🔄 Touch detected - restarting voice detection");
          speechRecognitionRef.current.start();
        }
      }
    };

    // Add touch event listeners for mobile
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchend', handleTouchStart, { passive: true });

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchStart);
    };
  }, [examStarted, isRecording]);

  // Special handling for last 30 seconds on mobile
  useEffect(() => {
    if (!examStarted || !isRecording || remainingSeconds >= 30) return;

    console.log("📱 Last 30 seconds - ensuring mobile microphone stays active");

    // Force restart voice detection in last 30 seconds
    const lastPhaseInterval = setInterval(() => {
      if (speechRecognitionRef.current && typeof speechRecognitionRef.current.isActive === 'function') {
        const isActive = speechRecognitionRef.current.isActive();
        if (!isActive) {
          console.log("🔄 Last 30 seconds - restarting voice detection on mobile");
          speechRecognitionRef.current.start();
        }
      }
    }, 2000); // Check every 2 seconds in last 30 seconds

    return () => clearInterval(lastPhaseInterval);
  }, [examStarted, isRecording, remainingSeconds]);

  const waveData = useAudioWave({
    active: isRecording,
    bars: 24,
    gain: 4.2,
    smoothing: 0.5,
    exponent: 0.45,
  });


  // Start exam with a small delay to ensure proper initialization
  useEffect(() => {
    if (isTask2MaintenanceEnabled() && !localStorage.getItem('current_task_attempt_id')) {
      return;
    }

    if (skipAutostartRef.current || examStarted || taskEnded) {
      return;
    }

    let cancelled = false;
    console.log('🎯 TaskOne mounted - starting exam in 500ms...');
    const timeoutId = window.setTimeout(() => {
      if (cancelled || skipAutostartRef.current || examStarted || taskEnded) {
        return;
      }
      void handleStartExam();
    }, 500);

    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [examStarted, taskEnded]);

  const handleAIResponse = (response: { text: string; audio?: string }) => {
    setAiQuestions(prev => {
      const incoming = (response.text || '').trim();
      const last = (prev[prev.length - 1] || '').trim();
      if (incoming && incoming === last) return prev;
      return [...prev, response.text];
    });
    setIsAISpeaking(true);
    setUserHasResponded(false);

    // Ensure microphone stays active during AI response
    if (speechRecognitionRef.current && typeof speechRecognitionRef.current.isActive === 'function') {
      const isActive = speechRecognitionRef.current.isActive();
      if (!isActive) {
        console.log("🔄 Restarting voice detection during AI response");
        speechRecognitionRef.current.start();
      }
    }
  };

  useEffect(() => {
    if (!timerActive || remainingSeconds <= 0 || taskEnded) return;
    const timer = setInterval(() => {
      setRemainingSeconds((prev) => {
        if (prev <= 1) {
          // Check if task was already ended by silence timer
          if (taskEnded) {
            console.log("⏰ Normal timer expired but task already ended - skipping");
            clearInterval(timer);
            return 0;
          }

          console.log("⏰ Normal timer expired - ending task");
          setTaskEnded(true);
          clearInterval(timer);
          setTimerActive(false);
          setExamStarted(false);
          setIsRecording(false);

          // Stop any ongoing AI audio from audio service
          if (audioServiceRef.current) {
            audioServiceRef.current.cancelAIAudio();
          }

          // Play static end audio with timeout fallback (3s)
          let hasNavigated = false;
          const navigationTimeout = setTimeout(() => {
            if (hasNavigated) return;
            console.warn('[TASK-ONE] ⏱️ Audio timeout - forcing navigation');
            hasNavigated = true;
            
            const isRetryAttempt = localStorage.getItem('current_task_attempt_id');
            if (isRetryAttempt) {
              console.log('🎯 (Timeout) TASK 1 RETRY - Navigating to Task1ProcessingScreen');
              navigate('/task1-processing');
            } else {
              console.log('🎯 (Timeout) TASK 1 - Navigating to Task 2');
              navigate('/task-two');
            }
          }, 3000);

          playStaticAudio('end', () => {
            if (hasNavigated) {
              console.log('[TASK-ONE] ⏭ Navigation already occurred via timeout');
              return;
            }
            clearTimeout(navigationTimeout);
            hasNavigated = true;
            console.log('✅ Timer end audio finished - navigating to Task 2');

            const isRetryAttempt = localStorage.getItem('current_task_attempt_id');
            if (isRetryAttempt) {
              console.log('🎯 TASK 1 RETRY - Navigating to Task1ProcessingScreen');
              navigate('/task1-processing');
            } else {
              console.log('🎯 TASK 1 - Navigating to Task 2');
              navigate('/task-two');
            }
          });
          return 0;
        }
        // Stop AI questions in last 30 seconds
        if (prev === 30) {
          setStatus("Last 30 seconds: AI will not ask new questions.");
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timerActive, remainingSeconds, taskEnded]);

  // Update audio service with remaining seconds
  useEffect(() => {
    if (audioServiceRef.current && examStarted) {
      audioServiceRef.current.setRemainingSeconds(remainingSeconds);
    }
  }, [remainingSeconds, examStarted]);


  // useEffect(() => {
  //   window.navigateToDashboard = () => {
  //     navigate('/task-two');
  //   };
  //   return () => {
  //     delete window.navigateToDashboard;
  //   };
  // }, [navigate]);
  useEffect(() => {
    window.navigateToDashboard = async () => {
      // 🔊 UNLOCK AUDIO CONTEXT FOR IOS
      try {
        const AC = (window as any).AudioContext || (window as any).webkitAudioContext;
        if (AC) {
          let ctx = (window as any).__appAudioContext;
          if (!ctx) {
            ctx = new AC();
            (window as any).__appAudioContext = ctx;
          }
          
          // Always try to resume
          if (ctx.state === 'suspended') {
            await ctx.resume();
          }
          
          // Play silent buffer to force unlock
          const buffer = ctx.createBuffer(1, 1, 22050);
          const source = ctx.createBufferSource();
          source.buffer = buffer;
          source.connect(ctx.destination);
          source.start(0);
          console.log('🔊 Audio context unlocked on Task 1 end, state:', ctx.state);
          
          // Short delay to ensure state propagates
          await new Promise(resolve => setTimeout(resolve, 50));
        }
      } catch (e) {
        console.warn('Failed to unlock audio context:', e);
      }

      setShowDivider(true);
      setTimeout(() => {
        setShowDivider(false);
        // Check if this is a retry attempt
        const isRetryAttempt = localStorage.getItem('current_task_attempt_id');
        if (isRetryAttempt) {
          console.log('🎯 TASK 1 RETRY - Navigating to SingleTaskFeedback for retry results');
          navigate('/single-task-feedback');
        } else {
          console.log('🎯 TASK 1 - Navigating to Task 2');
          navigate('/task-two');
        }
      }, 900); // 150+600+150ms for divider animation
    };
    return () => {
      delete window.navigateToDashboard;
    };
  }, [navigate]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (audioServiceRef.current) {
        audioServiceRef.current.cleanup();
      }
      if (speechRecognitionRef.current) {
        speechRecognitionRef.current.cleanup();
      }
    };
  }, []);

  // Disconnect Deepgram on route change
  useEffect(() => {
    const handleRouteChange = () => {
      console.log('🔌 Route changed - disconnecting Deepgram socket');
      if (audioServiceRef.current) {
        audioServiceRef.current.cleanup();
      }
      if (speechRecognitionRef.current) {
        speechRecognitionRef.current.cleanup();
      }
    };

    // Listen for route changes
    const unsubscribe = () => {
      // This will run when location changes
      handleRouteChange();
    };

    // Store current location to detect changes
    let currentLocation = location.pathname;

    const checkLocationChange = () => {
      if (location.pathname !== currentLocation) {
        console.log(`🔄 Route changed from ${currentLocation} to ${location.pathname} - disconnecting Deepgram`);
        handleRouteChange();
        currentLocation = location.pathname;
      }
    };

    // Use a polling approach since React Router doesn't provide a direct route change listener
    const intervalId = setInterval(checkLocationChange, 100); // Check every 100ms

    return () => {
      clearInterval(intervalId);
      handleRouteChange(); // Cleanup on unmount
    };
  }, [location.pathname]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSecs = seconds % 60;
    return `${minutes}:${remainingSecs.toString().padStart(2, '0')}`;
  };

  const playStaticAudioUrl = async (url: string, onEnd?: () => void) => {
    if (isLiveExamRuntimeExiting()) return;
    console.log(`🎵 Attempting to play audio from: ${url}`);
    const result = await playTrackedLiveExamAudio({
      url,
      audioContext: (window as Window & { __appAudioContext?: AudioContext }).__appAudioContext,
      onEnd,
    });
    if (result === 'aborted') {
      console.log('[TASK-ONE] Static audio aborted — runtime exiting');
    }
  };

  const playStaticAudio = async (type: StaticAudioType, onEnd?: () => void) => {
    if (isLiveExamRuntimeExiting()) return;
    try {
      const audioObj = getStaticAudioByType(type, 'task1');
      if (!audioObj) {
        console.error(`❌ No audio config found for type: ${type}`);
        onEnd && onEnd();
        return;
      }

      console.log(`🎵 Playing static audio: ${type} from ${audioObj.url}`);
      setIsAISpeaking(true);

      await playStaticAudioUrl(audioObj.url, () => {
        console.log(`✅ Static audio ${type} ended`);
        setIsAISpeaking(false);
        onEnd && onEnd();
      });
    } catch (error) {
      console.error(`❌ Error playing static audio ${type}:`, error);
      setIsAISpeaking(false);
      onEnd && onEnd();
    }
  };

  const playInitialPrompt = async () => {
    try {
      console.log("🎵 Playing initial prompt...");
      setStatus("Playing intro...");

      // Add 1 second delay before playing intro audio
      await new Promise(resolve => setTimeout(resolve, 1000));

      await playStaticAudio('start', () => {
        // Start timer immediately after intro finishes - timer runs for full 2 minutes
        console.log("🎯 Task 1: Intro finished - starting 2-minute timer now");
        setTimerActive(true);
        setIsRecording(true);

        setStatus("🎙️ Microphone active - ready for you to start speaking...");

        // Ensure microphone and voice detection are active
        if (audioServiceRef.current) {
          console.log("🎤 Ensuring microphone is active for speech detection");
          // Verify microphone is recording
          const connectionStatus = audioServiceRef.current.getConnectionStatus();
          console.log("🔍 Microphone status:", connectionStatus);
        }

        // Start speech recognition when timer begins
        if (speechRecognitionRef.current) {
          console.log("🎤 Starting speech recognition for 2-minute exam timer");
          const startSuccess = speechRecognitionRef.current.start();
          console.log("🎤 Speech recognition start result:", startSuccess);

          // Verify it's active
          setTimeout(() => {
            const isActive = speechRecognitionRef.current?.isActive();
            const isHealthy = speechRecognitionRef.current?.isHealthy?.() ?? true;
            console.log("🎤 Speech recognition status after start:", { isActive, isHealthy });
          }, 1000);
        }
      });
    } catch (error) {
      console.error("❌ Error playing initial prompt:", error);
      // Even if intro fails, start the timer immediately
      console.log("🎯 Task 1: Intro failed - starting 2-minute timer now");
      setTimerActive(true);
      setStatus("🎙️ Microphone active - ready for you to start speaking...");

      // Ensure microphone and speech detection are active even if intro failed
      if (audioServiceRef.current) {
        console.log("🎤 Ensuring microphone is active for speech detection (intro failed)");
        const connectionStatus = audioServiceRef.current.getConnectionStatus();
        console.log("🔍 Microphone status:", connectionStatus);
      }

      if (speechRecognitionRef.current) {
        console.log("🎤 Starting speech recognition for 2-minute exam timer (intro failed)");
        const startSuccess = speechRecognitionRef.current.start();
        console.log("🎤 Speech recognition start result (intro failed):", startSuccess);

        // Verify it's active
        setTimeout(() => {
          const isActive = speechRecognitionRef.current?.isActive();
          const isHealthy = speechRecognitionRef.current?.isHealthy?.() ?? true;
          console.log("🎤 Speech recognition status after start (intro failed):", { isActive, isHealthy });
        }, 1000);
      }
    }
  };

  const handleStartExam = async () => {
    if (isTask2MaintenanceEnabled() && !localStorage.getItem('current_task_attempt_id')) {
      return;
    }

    // Prevent multiple starts — and never create AudioService after a Trial redirect
    if (skipAutostartRef.current || examStarted || taskEnded) {
      console.log('⚠️ handleStartExam already called or task ended - skipping');
      return;
    }

    try {
      console.log('🚀 Starting Task 1 exam...');

      // Enhanced mobile audio context handling
      try {
        const AC: any = (window as any).AudioContext || (window as any).webkitAudioContext;
        if (AC) {
          let ctx: AudioContext | undefined = (window as any).__appAudioContext;
          if (!ctx || ctx.state === 'closed') {
            console.log('🔧 Creating new AudioContext...');
            ctx = new AC();
            (window as any).__appAudioContext = ctx;
          }

          console.log('🔧 AudioContext state:', ctx.state);

          // If already running, we're good!
          if (ctx.state === 'running') {
             console.log('✅ AudioContext is already running, reusing it.');
          } else if (ctx.state === 'suspended') {
            console.log('🔧 Resuming suspended AudioContext...');
            await ctx.resume();
            // Additional mobile-specific resume check
            if (ctx.state === 'suspended') {
              console.log('🔧 AudioContext still suspended, retrying...');
              await new Promise(resolve => setTimeout(resolve, 100));
              await ctx.resume();
            }
          }

          // Keep audio context alive on mobile
          const keepAlive = () => {
            if (ctx && ctx.state === 'suspended') {
              ctx.resume().catch(() => { });
            }
          };

          // Resume audio context on user interaction (mobile requirement)
          document.addEventListener('touchstart', keepAlive, { once: true });
          document.addEventListener('touchend', keepAlive, { once: true });
          document.addEventListener('click', keepAlive, { once: true });
        }
        console.log('🔓 Audio context unlocked for Task 1 (mobile optimized)');
      } catch (e) {
        console.warn('AudioContext unlock failed:', e);
      }

      // Initialize AudioService first and prepare Deepgram immediately with same mic stream
      const [audioService, speechService] = await Promise.all([
        // Initialize AudioService
        (async () => {
          const service = new AudioService(
            {
              websocketUrl: import.meta.env.VITE_WEBSOCKET_URL,
              delayAssistantSpoken: true, // Task 1: delay sending assistant_spoken until confirmed
            },
            {
              onStatusChange: (status) => setStatus(status),
              onConnectionChange: (connected) => setIsConnected(connected),
              onTranscriptUpdate: (transcript) => {
                setFullTranscript(transcript);

                // Store transcript for task attempt if this is a retry
                const currentAttemptId = localStorage.getItem('current_task_attempt_id');
                if (currentAttemptId && transcript) {
                  localStorage.setItem('current_task_transcript', transcript);
                  console.log('💾 TASK 1 RETRY - Stored transcript for attempt:', currentAttemptId);
                }
              },
              onLiveTranscriptUpdate: (transcript) => setLiveTranscript(transcript),

              onAIResponse: handleAIResponse,
              onAIQuestionDisplay: (question) => {
                const incoming = (question || '').trim();
                setCurrentDisplayedQuestion(incoming);
                setAiQuestions(prev => {
                  const last = (prev[prev.length - 1] || '').trim();
                  if (incoming && incoming === last) return prev;
                  return [...prev, question];
                });
                setUserHasResponded(false);
              },
              onAIQuestionComplete: (question) => {
                // Clear the active displayed question after it finished playing
                setCurrentDisplayedQuestion(null);
                // Flush the buffered assistant_spoken so backend is only notified after
                // full playback (prevents premature counting when AI was interrupted)
                try {
                  audioServiceRef.current?.flushBufferedAssistantSpoken();
                } catch (err) {
                  console.warn('Failed to flush buffered assistant_spoken:', err);
                }
              },
              onAIQuestionHide: () => {
                // If a question was being displayed and now hidden (interrupted), remove it from visible questions
                if (currentDisplayedQuestion) {
                  setAiQuestions(prev => {
                    // remove the last occurrence of currentDisplayedQuestion
                    const idx = prev.map(q => (q || '').trim()).lastIndexOf(currentDisplayedQuestion.trim());
                    if (idx === -1) return prev;
                    const copy = [...prev];
                    copy.splice(idx, 1);
                    return copy;
                  });
                  setCurrentDisplayedQuestion(null);
                }
              },
              onError: (error) => setStatus(`Error: ${error}`),
              onUserSpeaking: () => {
                setStatus("🗣️ User speaking...");
                setIsUserSpeaking(true);

                // If this is the first time user speaks, enable conversation flow
                if (!userHasSpokenFirst) {
                  console.log("🎯 First user speech detected - enabling conversation flow");
                  setUserHasSpokenFirst(true);
                  setStatus("🗣️ User speaking...");

                  // Notify audio service that user has spoken first
                  if (audioServiceRef.current) {
                    audioServiceRef.current.setUserHasSpokenFirst(true);
                  }
                }

                if (aiQuestions.length > 0 && !userHasResponded) {
                  setUserHasResponded(true);
                }
              },
              onUserStoppedSpeaking: () => {
                setStatus("🤫 Detecting silence...");
                setIsUserSpeaking(false);
              },
              onMicActivate: () => {
                // Voice detection already started immediately
                setIsAISpeaking(false);
                setStatus("Listening...");
              },
              onMicDeactivate: () => {
                // No need to deactivate mic during AI responses - keep voice detection always active
                console.log("ℹ️ AI speaking - voice detection remains active for user interruption");
                // Ensure voice detection stays active by checking and restarting if needed
                if (speechRecognitionRef.current && typeof speechRecognitionRef.current.isActive === 'function') {
                  const isActive = speechRecognitionRef.current.isActive();
                  if (!isActive) {
                    console.log("🔄 Restarting voice detection during AI response");
                    speechRecognitionRef.current.start();
                  }
                }
              },
              onTaskSaved: (taskId) => {
                console.log('🎯 Task saved to database, task ID:', taskId);

                // Check for session ID - prioritize current_exam_id for retry scenarios
                const sessionIdFromStorage = getSessionId();
                const currentExamId = localStorage.getItem('current_exam_id');
                const sessionId = currentExamId || sessionIdFromStorage;

                console.log('🎯 TASK 1 - Session ID resolution:', {
                  sessionIdFromStorage,
                  currentExamId,
                  finalSessionId: sessionId,
                  source: currentExamId ? 'current_exam_id (retry)' : 'session_id (normal)'
                });

                // Only call grammar analysis for retry attempts
                const isRetryAttempt = localStorage.getItem('current_task_attempt_id');
                if (isRetryAttempt && sessionId) {
                  // console.log('🎯 TASK 1 RETRY - Calling grammar analysis for retry attempt');
                  // // Add a small delay to ensure database transaction is committed
                  // setTimeout(() => {
                  //   callGrammarAnalysis(sessionId).catch(error => {
                  //     console.error('Grammar analysis failed:', error);
                  //   });
                  // }, 1000); // 1 second delay
                } else {
                  console.log('🎯 TASK 1 NORMAL FLOW - Skipping grammar analysis (will be handled by final scoring)');
                }
              },
              onTaskEnded: () => {
                console.log('🔇 Task ended by silence timer - stopping normal timer');
                setTaskEnded(true);
                setTimerActive(false);
                setExamStarted(false);
                setIsRecording(false);
                // Note: stopRecording() is already called by AudioService internally
              },
              onEndMessageFinished: () => {
                console.log('✅ Silence timer end audio finished - navigating immediately');
                setShowDivider(true);
                
                const isRetryAttempt = localStorage.getItem('current_task_attempt_id');
                
                // Simple timeout - just navigate quickly
                setTimeout(() => {
                  setShowDivider(false);
                  if (isRetryAttempt) {
                    console.log('🎯 TASK 1 RETRY - Navigating to Task1ProcessingScreen (silence-triggered)');
                    navigate('/task1-processing');
                  } else {
                    console.log('🎯 TASK 1 - Navigating to Task 2');
                    navigate('/task-two');
                  }
                }, 500);
              },
            }
          );

          service.setRemainingSeconds(remainingSeconds);
          return service;
        })(),
        (async () => null)
      ]);

      // Store references
      audioServiceRef.current = audioService;

      // Ensure AudioService has initialized mic stream
      if (audioServiceRef.current && typeof (audioServiceRef.current as any).initialize === 'function') {
        await (audioServiceRef.current as any).initialize();
      }

      // Start Deepgram immediately using the same mic stream
      try {
        const mediaStream = audioServiceRef.current?.getMediaStream();
        console.log("🎤 Starting Deepgram with existing MediaStream:", !!mediaStream);
        const dg = new DeepgramTranscriptionService({
          onInterimResult: (transcript) => {
            setLiveTranscript(transcript);
            audioServiceRef.current?.handleUserSpeech(transcript, "");
          },
          onFinalResult: (transcript) => {
            audioServiceRef.current?.handleUserSpeech("", transcript);
          },
          onError: (error) => setStatus(`Speech Error: ${error}`)
        }, {
          existingMediaStream: mediaStream || undefined
        });
        speechRecognitionRef.current = dg as any;
        dg.start();
      } catch (e) {
        console.warn('⚠️ Failed to start Deepgram early:', e);
      }

      // Start audio service; Deepgram already started above with shared stream
      const recordingSuccess = await audioService.startRecording();
      let voiceDetectionSuccess = true;

      if (recordingSuccess && voiceDetectionSuccess) {
        // Ensure AI audio is enabled at start of task
        audioServiceRef.current?.enableAIAudio?.();
        setExamStarted(true);
        // setIsRecording(true);
        setStatus("Microphone active - starting with initial prompt...");

        // Play initial prompt immediately - timer will start after intro finishes
        try {
          await playInitialPrompt();
          console.log('✅ Task One exam started successfully with instant mic and voice detection');
        } catch (error) {
          console.error('❌ Error playing initial prompt, but continuing with exam:', error);
          // Timer should already be started by playInitialPrompt, but ensure it's running
          if (!timerActive) {
            setTimerActive(true);
            setStatus("🎙️ Microphone active - ready for you to start speaking...");
          }
        }
      } else {
        console.error('❌ Failed to start recording or voice detection');
        setStatus("Failed to start recording or voice detection");
      }
    } catch (error) {
      console.error('❌ Error starting exam:', error);
      setStatus("Error starting exam");
    }
  };

  useEffect(() => {
    if (!('MediaRecorder' in window)) {
      setStatus("Error: MediaRecorder not supported for Deepgram.");
    }
  }, []);

  // Handle browser back button - redirect to mic-test and stop all audio
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      event.preventDefault();

      // Stop all audio and recording immediately
      if (audioServiceRef.current) {
        audioServiceRef.current.stopRecording();
        audioServiceRef.current.cancelAIAudio();
      }

      if (speechRecognitionRef.current) {
        speechRecognitionRef.current.cleanup();
      }

      // Stop any local audio elements
      try {
        const audioElements = document.querySelectorAll('audio');
        audioElements.forEach(audio => {
          audio.pause();
          audio.currentTime = 0;
          audio.src = '';
        });

        // Stop Web Audio API contexts
        const audioContext = (window as any).__appAudioContext;
        if (audioContext && audioContext.state !== 'closed') {
          audioContext.close().catch(() => { });
        }
      } catch (error) {
        console.warn('Error during audio cleanup on back button:', error);
      }

      // Redirect to mic-test page
      navigate('/mic-test', { replace: true });
    };

    // Add event listener
    window.addEventListener('popstate', handlePopState);

    // Push a state to prevent immediate back navigation
    window.history.pushState(null, '', window.location.href);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  // Function to play the closing line and handle transition
  const handleFinishTask = async () => {
    setShowExitModal(false);
    // Prevent multiple calls
    if (taskEnded) {
      console.log('⚠️ handleFinishTask already called - ignoring duplicate call');
      return;
    }

    console.log('🎯 handleFinishTask called - ending Task 1');
    // 1️⃣ Immediately terminate ALL AI activity in AudioService
    if (audioServiceRef.current) {
      audioServiceRef.current.finishTaskImmediately();
    }

    // 2️⃣ Stop recording immediately
    setTaskEnded(true);
    setIsRecording(false);
    setExamStarted(false);
    setTimerActive(false);
    setRemainingSeconds(120);
    setIsAISpeaking(false);

    // Get session ID for grammar analysis
    const sessionId = getSessionId();
    console.log('🎯 Task 1 finishing, session ID:', sessionId);

    // Display the end message text on screen
    const endMessageObj = getStaticAudioByType("end", 'task1');
    if (endMessageObj) {
      setAiQuestions(prev => [...prev, endMessageObj.text]);
    }

    // Play static end audio with timeout fallback (3s)
    let hasNavigated = false;
    const navigationTimeout = setTimeout(() => {
      if (hasNavigated) return;
      console.warn('[TASK-ONE] ⏱️ Audio timeout in handleFinishTask - forcing navigation');
      hasNavigated = true;
      
      const isRetryAttempt = localStorage.getItem('current_task_attempt_id');
      if (isRetryAttempt) {
        console.log('🎯 (Timeout) TASK 1 RETRY - Navigating to Task1ProcessingScreen');
        navigate('/task1-processing');
      } else {
        console.log('🎯 (Timeout) TASK 1 - Navigating to Task 2');
        navigate('/task-two');
      }
    }, 3000);

    playStaticAudio("end", () => {
      if (hasNavigated) {
        console.log('[TASK-ONE] ⏭ Navigation already occurred via timeout');
        return;
      }
      clearTimeout(navigationTimeout);
      hasNavigated = true;
      console.log('✅ Finish button end audio finished - navigating');

      const isRetryAttempt = localStorage.getItem('current_task_attempt_id');
      if (isRetryAttempt) {
        console.log('🎯 TASK 1 RETRY - Navigating to Task1ProcessingScreen');
        navigate('/task1-processing');
      } else {
        console.log('🎯 TASK 1 - Navigating to Task 2');
        navigate('/task-two');
      }
    });
  };


  const handleExitExam = () => {
    setShowExitModal(true);
  };


  const handleConfirmExit = () => {
    markLiveExamRuntimeExiting();
    setShowExitModal(false);

    // Stop everything cleanly
    setIsRecording(false);
    setExamStarted(false);
    setRemainingSeconds(120);
    setIsAISpeaking(false);
    setAiQuestions([]);
    setFullTranscript("");
    setLiveTranscript("");
    setUserHasResponded(false);
    setIsUserSpeaking(false);
    setStatus("Ready to start");

    if (audioServiceRef.current) {
      audioServiceRef.current.cleanup();
      // Explicitly close global audio context on exit
      audioServiceRef.current.cleanupGlobalAudio();
    }
    if (speechRecognitionRef.current) {
      speechRecognitionRef.current.cleanup();
    }

    // ⏳ Wait a tick so modal closes first
    setTimeout(() => {
      const token = localStorage.getItem("access_token");
      if (token) {
        window.location.href = '/dashboard';
      } else {
        window.location.href = 'https://prep2pass.ca';
      }
    }, 100);
  };

  const handleContinueExam = () => {
    setShowExitModal(false);
  };

  // if (showPreStartMessage) {
  //   return (
  //     <div className="fixed inset-0 bg-white/95 backdrop-blur-sm flex items-center justify-center z-50">
  //       <div className="text-center space-y-4">
  //         {/* <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
  //           <Mic className="w-8 h-8 text-white " />
  //         </div> */}
  //         <h3 className="text-[3rem] font-semibold text-[#1C1F26] leading-[3.5rem]">
  //           Get ready. The first task is about to begin.
  //         </h3>
  //       </div>
  //     </div>
  //   );
  // }

  // useBlocker(({ location: nextLoc }) => {
  //   if (!allowInternalNavigation && nextLoc.pathname !== location.pathname) {
  //     // User is trying to navigate away manually (not internally)
  //     // setNextLocation(nextLoc.pathname);
  //     handleExitExam(); // show confirmation modal
  //     return false; // block navigation
  //   }
  // }, true);
  // ;
  if (isTask2MaintenanceEnabled() && !isRetryAttempt) {
    return (
      <Task2MaintenancePage
        subtitle="The full speaking exam is paused while we restore Task 2 live voice practice. You can return to the dashboard for individual Task 1 or Task 3 practice, or review your results."
      />
    );
  }

  return (
    <div className="exam-container">
      <main id="exam" className="exam-main" aria-label="TCF Speaking Exam Task 1">
        <header className="exam-header">
          <div className="header-inner">
            <div className="header-left">
              <span className="task-badge" aria-current="step">
                {/* Tâche 1 sur 3 */}
                {isRetryAttempt ? "Tâche 1" : "Tâche 1 sur 3"}
              </span>
            </div>

            <div className="header-right" role="group" aria-label="Status">
              <time
                className={`timer ${remainingSeconds === 0 ? 'freeze' : timerActive ? 'active' : 'idle'}`}
                aria-live="polite"
                aria-atomic="true"
                dateTime={`PT${remainingSeconds}S`}
              >
                {formatTime(remainingSeconds)}
              </time>

              <span className="recording" role="status" aria-live="polite">
                <span className="record-dot" aria-hidden="true" />
                <span className="record-text">
                  {isRecording ? "Microphone Active" : "Microphone Inactive"}
                  {/* {isRecording ? "Microphone active" : "Microphone inactive"} */}
                </span>
                <span
                  className={`record-bars ${isRecording ? "animate" : ""}`}
                  aria-hidden="true"
                >
                  <i /><i /><i /><i /><i />
                </span>
              </span>
            </div>

            <button
              type="button"
              className="exit-btn"
              onClick={handleExitExam}
              aria-label="Exit Exam"
            >
              Quitter l’examen
            </button>
          </div>
        </header>
        <section className="content">
          <div
            className="ai-messages"
            aria-live="polite"
            ref={messagesRef}
          >
            <div className="ai-bubble">
              {aiQuestions.length > 0 ? (
                aiQuestions.map((msg, idx) => (
                  <div
                    key={idx}
                    className="ai-qus-wrapper"
                  >
                    <img src={logo} alt="Logo" style={{ width: '22px', marginTop: '-2px' }} />
                    <strong className="ai-label">AI:</strong>
                    <p className={`text-ai ${idx < aiQuestions.length - 1 ? "text-gray dim" : "fade-in"}`}>
                      {msg}
                    </p>
                  </div>
                ))
              ) : (
                <div className="ai-qus-wrapper ai-qus-wrapper--shell" aria-hidden="true" />
              )}
            </div>
          </div>
          <div
            className={`prompt-card ${isRecording ? "is-recording" : "is-idle"}`}
            role="region"
            aria-label="Task 1 Prompt"
          >
            <div>
              <p className="prompt-title" >Parlez-moi de vous.</p>
                </div>
                  <div className={`card-wave ${isWaveActive ? "active" : "idle"}`} aria-hidden="true">
                    {waveData.map((amp, i) => (
                      <span
                        key={i}
                        style={{
                          transform: `scaleY(${isWaveActive ? amp : 1})`
                        }}
                      />
                    ))}
                  </div>
                </div>

        </section>
        <div className="finish-button-container">
          {isRecording && timerActive && (
            <button className="finish-btn" onClick={handleFinishTask}>
              Terminer la tâche
            </button>
          )}
        </div>
        <ExitExamDialog
          open={showExitModal}
          onOpenChange={(open) => {
            setShowExitModal(open);
          }}
          onContinue={handleContinueExam}
          onConfirm={handleConfirmExit}
        />
        {/* {showDivider && (
        <div className="divider-overlay" aria-hidden="true">
          <span className="divider-chip">Task 1 complete</span>
        </div>
      )} */}
      </main>
    </div>
  );
};

export default TaskOne;

